// Port of api/fuel/app/classes/insights/collection/weight.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Game from 'offline/model/game'

export default Segment.extend({
    name: 'weight',
    insight: false,
    detail: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var weights = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

        var collectionIndex = this._data.base

        if (collectionIndex.length) {

            var weightIndex = Game.filter({
                arrayed: true,
                select: {
                    plain: [
                        'game_id',
                        'game_weight_avg'
                    ]
                },
                where: [
                    ['game_id', 'in', collectionIndex.filter(function(v, i, a) { return a.indexOf(v) === i })]
                ]
            })

            for (var i = 0; i < weightIndex.length; i++) {
                var w = weightIndex[i].game_weight_avg

                if (w <= 1.24) weights[0]++
                else if (w <= 1.49) weights[1]++
                else if (w <= 1.74) weights[2]++
                else if (w <= 1.99) weights[3]++
                else if (w <= 2.24) weights[4]++
                else if (w <= 2.49) weights[5]++
                else if (w <= 2.74) weights[6]++
                else if (w <= 2.99) weights[7]++
                else if (w <= 3.24) weights[8]++
                else if (w <= 3.49) weights[9]++
                else if (w <= 3.74) weights[10]++
                else if (w <= 3.99) weights[11]++
                else if (w <= 4.24) weights[12]++
                else if (w <= 4.49) weights[13]++
                else if (w <= 4.74) weights[14]++
                else if (w <= 5) weights[15]++
            }

        }

        return {
            weights: weights
        }

    }
})
